<template>
    <section>
        <ds-modal
            :is-open="isOpen"
            dialog
            :size="modalSize"
            data-qa="fileModal"
            @close="modalClose"
        >
            <div>
                <h3>Confirm File Replace</h3>

                <h5>Matching file was found</h5>

                <p>A file with the same name as the file you are uploading was found. Would you like to replace the old file with the new one?</p>

                <p><b>*Important:</b> If you choose NOT to replace the old file with the new one, any marketing pieces linked to the original file will not be linked to the new file. If you choose to overwrite the old file, those emails will include the new file (the one you just uploaded).</p>

                <ul>
                    <li>File Name: {{ newFileName }}</li>
                    <li>Original File Size: {{ originalFileSize }}</li>
                    <li>New File Size: {{ newFileSize }}</li>
                    <li>What would you like to do?</li>
                </ul>

                <ds-outline-button
                    class="upload-button"
                    data-qa="replace-old-with-new"
                    @click="replaceOldFileWithNew"
                >
                    Replace Old File With New
                </ds-outline-button>

                <ds-outline-button
                    class="upload-button"
                    data-qa="keep-both-files"
                    @click="keepBothFiles"
                >
                    Upload New File & Keep Old File
                </ds-outline-button>
            </div>
        </ds-modal>
    </section>
</template>
<script>
export default {
    props: {
        newFileName: String,
        newFileSize: Number,
        originalFileSize: Number,
    },

    data() {
        return {
            modalSize: 'med',
            isOpen: false,
        };
    },

    methods: {
        showModal() {
            this.isOpen = true;
        },

        modalClose() {
            this.isOpen = false;
        },

        replaceOldFileWithNew() {
            this.$emit('replaceOldFileWithNew');
        },

        keepBothFiles() {
            this.$emit('keepBothFiles');
        },
    },
};

</script>

<style lang="scss" scoped>
    .upload-button {
        margin: $spacing-200  $spacing-150 $spacing-200  0;
    }

    h3 {
        margin-bottom: $spacing-200;
    }

    h5 {
        font-size: $font-size-md;
        font-weight: $font-weight-semibold;
        margin-bottom: $spacing-200;
    }
</style>
